import React from 'react';
import './KeyInformation.css';

export default class KeyInformation extends React.Component {
	
	static defaultProps = {
		header: 'Key information',
		className: '',
		vacancy: {
			jobTitle: '',
			postedDate: '',
			contact: '',
			jobType: '',
			startDate: '',
			salary: '',
		}
	};
	
	render = () => {
		return (
			<div className={`${this.props.className} rcg-information-container`}>
				
				<div>
					<h3 className="rcg-small-title text-outline">{this.props.header}</h3>
				</div>
				
				<div className="vacancy-overview">
					
					<div className={'vacancy-wrapper'}>
						<div className={'vacancy-col-flex'}>
							<div className={'vacancy-col-flex-inner'}>
								
								<div className="single-block-in-column">
									<h6 className="h6-rcg">Job Title</h6>
									<p className="user-content">
										{this.props.vacancy.jobTitle}
									</p>
								</div>
								
								<div className="single-block-in-column">
									<h6 className="h6-rcg">Date Posted</h6>
									<p className="user-content">
										{this.props.vacancy.postedDate}
									</p>
								</div>
								
								<div className="single-block-in-column">
									<h6 className="h6-rcg">Contact</h6>
									<p className="user-content">
										{this.props.vacancy.contact}
									</p>
								</div>
								
							</div>
						</div>
						<div className={'vacancy-col-flex'}>
							<div className={'vacancy-col-flex-inner'}>
								
								<div className="single-block-in-column">
									<h6 className="h6-rcg">Job Type</h6>
									<p className="user-content">
										{this.props.vacancy.jobType}
									</p>
								</div>
								
								<div className="single-block-in-column">
									<h6 className="h6-rcg">Start Date</h6>
									<p className="user-content">
										{this.props.vacancy.startDate}
									</p>
								</div>
								
								<div className="single-block-in-column">
									<h6 className="h6-rcg">Salary</h6>
									<p className="user-content">
										{this.props.vacancy.salary}
									</p>
								</div>
								
							</div>
						</div>
					</div>
				
				</div>
			
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/VacancyOverview/KeyInformation.js